import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSpecialties } from '../../../redux/resources/resourcesSlice';
import { RootState, AppDispatch } from '../../../redux/';

interface Specialty {
  _id: string;
  name: string;
  description?: string;
}

// Transform function to convert _id to id for component compatibility
const transformSpecialties = (specialties: Specialty[]) => {
  return specialties.map(specialty => ({
    ...specialty,
    id: specialty._id // Map _id to id for component
  }));
};

export const useFetchSpeciality = () => {
  const dispatch = useDispatch<AppDispatch>();
  
  // Add debugging to see the actual state structure
  const fullState = useSelector((state: RootState) => state);
  const resourcesState = useSelector((state: RootState) => state.resources);
  
  const specialties = useSelector((state: RootState) => state.resources?.specialties || []);
  const loading = useSelector((state: RootState) => state.resources?.isLoading || false);
  const error = useSelector((state: RootState) => state.resources?.error || null);

  useEffect(() => {
    
    // Dispatch the action
    dispatch(fetchSpecialties());
  }, [dispatch]);

  // Debug the returned values

  return { 
    specialties: transformSpecialties(specialties), 
    loading, 
    error 
  };
};

export default useFetchSpeciality;
